/** Shared primary action button styles (Manage Items / Categories pattern). */
export const getThemeGradientButtonStyle = (themeColor) => ({
  backgroundColor: themeColor,
  background: `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`,
  border: "none",
  color: "white",
  borderRadius: "8px",
  padding: "8px 16px",
  fontSize: "14px",
  fontWeight: "600",
  transition: "all 0.3s ease",
  boxShadow: `0 2px 8px ${themeColor}40`,
});

export const onThemeGradientButtonEnter = (e, themeColor) => {
  e.target.style.background = `linear-gradient(135deg, ${themeColor}dd 0%, ${themeColor} 100%)`;
  e.target.style.transform = "translateY(-1px)";
  e.target.style.boxShadow = `0 4px 12px ${themeColor}60`;
};

export const onThemeGradientButtonLeave = (e, themeColor) => {
  e.target.style.background = `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`;
  e.target.style.transform = "translateY(0)";
  e.target.style.boxShadow = `0 2px 8px ${themeColor}40`;
};
